// src/components/BenefitComponent2.js
import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/scrollAnimations.css';
import './BenefitComponent2.css';

const BenefitComponent2 = ({ imageSrc, iconSrc, headerText, absoluteText, title, description, buttonText, buttonLink }) => {
  const [headerRef, headerVisible] = useScrollAnimation({ threshold: 0.2 });
  const [titleRef, titleVisible] = useScrollAnimation({ threshold: 0.2 });
  const [descriptionRef, descriptionVisible] = useScrollAnimation({ threshold: 0.2 });
  const [buttonRef, buttonVisible] = useScrollAnimation({ threshold: 0.2 });

  return (
    <div className="benefit2-wrapper">
      <div className="benefit2-component">
        <div className="benefit2-container">
          <div 
            ref={headerRef}
            className={`header2 scroll-fade-in ${headerVisible ? 'is-visible' : ''}`}
          >
          <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={iconSrc} alt="Icon" className="icon2" />
              <p className="header2-text">{headerText}</p>
            </div>
            <p className="absolute2-text">{absoluteText}</p>
          </div>
          <img src={imageSrc} alt="Example" className="benefit-image-inside" />
          <h2 
            ref={titleRef}
            className={`benefit2-title scroll-fade-in scroll-animation-delay-1 ${titleVisible ? 'is-visible' : ''}`}
          >
            {title}
          </h2>
          <p 
            ref={descriptionRef}
            className={`benefit2-description scroll-fade-in scroll-animation-delay-2 ${descriptionVisible ? 'is-visible' : ''}`}
          >
            {description}
          </p>
          <a 
            ref={buttonRef}
            href={buttonLink} 
            target="_blank" 
            rel="noreferrer"
            className={`benefit-wrapper-button scroll-fade-in-scale scroll-animation-delay-3 ${buttonVisible ? 'is-visible' : ''}`}
          >
            {buttonText}
          </a>
        </div>
      </div>
      <div className="image2-wrapper">
        <img src={imageSrc} alt="Example" className="benefit2-image" />
      </div>
    </div>
  );
};

export default BenefitComponent2;
